import { rawGet } from "./FetchService";

const getArweaveAssetData = async (uri: string): Promise<any> => {
  return await rawGet(uri);
};

export { getArweaveAssetData };
